import { inject, Injectable } from "@angular/core";
import { ApiBaseService } from "@app/core/services/api-base.service";
import { Observable } from "rxjs";
import { AxSalesBasketResponse } from "../models/responses.model";
import { SalesSegment } from "../models/sales-segment.model";


@Injectable({
    providedIn: 'root'
})
export class ReclaimApiService {

    private readonly API_PATH_RECLAIM: string = 'reclaim'

    #apiBaseService = inject(ApiBaseService)

    createReclaim(copyFromSalesBasketId: string, versionName: string, isWarranty: boolean, lines: any): Observable<AxSalesBasketResponse> {

        const payload = {
            copyFromSalesBasketId,
            versionName,
            isWarranty,
            lines
        }

        return this.#apiBaseService.observablePost<AxSalesBasketResponse>(`${this.API_PATH_RECLAIM}/Do_CreateReclaim`, payload)
    }

    getSalesSegments(): Observable<{AllOk: boolean, Message: SalesSegment[]}> {
        return this.#apiBaseService.observablePost<any>(`${this.API_PATH_RECLAIM}/Fetch_SalesSegments`, {});
    }

    getSalesSegment(salesBasketId: string): Observable<{AllOk: boolean, Message: SalesSegment}> {
        return this.#apiBaseService.observablePost<any>(`${this.API_PATH_RECLAIM}/Fetch_SalesSegment`, { salesBasketId });
    }

    /**
     * Get references to all reclaims created from this order
     * @param salesId
     */
    getReclaimSalesReferences(salesId: string): Observable<any> {
        return this.#apiBaseService.observablePost<any>(`${this.API_PATH_RECLAIM}/Fetch_ReclaimSalesReferences`, { salesId });
    }

    getCurrentReclaimSalesReference(salesBasketId: string): Observable<any> {
        const payload = {
            salesBasketId
        }

        return this.#apiBaseService.observablePost(`${this.API_PATH_RECLAIM}/Fetch_CurrentReclaimSalesReference`, payload);
    }

    getReclaimCreatedBy(salesBasketId: string): Observable<any> {
        const payload = {
            salesBasketId
        }

        return this.#apiBaseService.observablePost(`${this.API_PATH_RECLAIM}/Fetch_ReclaimCreatedBy`, payload);
    }

    changeSalesSegment(salesBasketId: string, salesSegment: string): Observable<any> {
        const payload = {
            salesBasketId,
            salesSegment
        }

        return this.#apiBaseService.observablePost(`${this.API_PATH_RECLAIM}/Do_ChangeSalesSegment`, payload);
    }

    changeIsWarranty(salesBasketId: string, isWarranty: boolean): Observable<any> {
        const payload = {
            salesBasketId,
            isWarranty
        }

        return this.#apiBaseService.observablePost(`${this.API_PATH_RECLAIM}/Do_ChangeIsWarranty`, payload);
    }

    changeCreatorWillSignWorkorder(salesBasketId: string, creatorWillSign: boolean): Observable<any> {
        const payload = {
            salesBasketId,
            isCreatorSign: creatorWillSign
        }

        return this.#apiBaseService.observablePost(`${this.API_PATH_RECLAIM}/SetCreatorSignatory`, payload)
    }

    createCrmReclaimOrder(salesBasketId: string): Observable<any> {
        const payload = {
            salesBasketId
        }

        return this.#apiBaseService.observablePost<any>(`${this.API_PATH_RECLAIM}/Do_CreateCrmReclaimOrder`, payload)
    }

}
